let account_details_form = require( './account-details-form' );

let registration_form = (function( $ ) {

	let selector = '#phase-2-registration';

	let _init = function() {
		if ( $( selector ).length > 0 ) {
			account_details_form.init( selector );
		}
	};

	$( document ).ready( _init );

})( jQuery );

module.exports = registration_form;